import React, { useState } from 'react';
import './StatusCard.scss';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Tag } from 'primereact/tag';

const StatusCard = ({ rend, title, amount, change, isPositive, id, onBudgetUpdate }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editedRend, setEditedRend] = useState(rend);

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        setIsEditing(false);
        onBudgetUpdate(id, editedRend);
    };

    const handleCancel = () => {
        setIsEditing(false);
        setEditedRend(rend);
    };

    return (
        <Card className="status-card">
            <div className="status-card-content">
                {/* Header - Título */}
                <div className="card-title">
                    <h3>{title}</h3>
                </div>

                {/* Número principal - Unidades */}
                <div className="card-amount">
                    <span className="amount-number">{amount}</span>
                </div>

                {/* Presupuesto - Editable */}
                <div className="card-budget">
                    {isEditing ? (
                        <div className="budget-edit-mode">
                            <InputNumber
                                value={editedRend}
                                onValueChange={(e) => setEditedRend(e.value)}
                                useGrouping={false}
                                className="budget-input"
                                placeholder="Presupuesto"
                                min={0}
                            />
                            <div className="edit-actions">
                                <Button
                                    icon="pi pi-check"
                                    rounded
                                    text
                                    severity="success"
                                    size="small"
                                    onClick={handleSaveClick}
                                    tooltip="Guardar"
                                    tooltipOptions={{ position: 'bottom' }}
                                />
                                <Button
                                    icon="pi pi-times"
                                    rounded
                                    text
                                    severity="danger"
                                    size="small"
                                    onClick={handleCancel}
                                    tooltip="Cancelar"
                                    tooltipOptions={{ position: 'bottom' }}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="budget-view-mode">
                            <span className="budget-label">Presupuesto</span>
                            <div className="budget-value-container">
                                <span className="budget-value">{rend}</span>
                                <Button
                                    icon="pi pi-pencil"
                                    rounded
                                    text
                                    severity="secondary"
                                    size="small"
                                    onClick={handleEditClick}
                                    tooltip="Editar presupuesto"
                                    tooltipOptions={{ position: 'bottom' }}
                                />
                            </div>
                        </div>
                    )}
                </div>

                {/* Porcentaje de cambio */}
                <div className="card-change">
                    <Tag
                        icon={isPositive ? 'pi pi-arrow-up' : 'pi pi-arrow-down'}
                        severity={isPositive ? 'success' : 'danger'}
                        value={`${change} %`}
                        className="change-tag"
                    />
                </div>
            </div>
        </Card>
    );
};

export default StatusCard;
